import { type FC, useEffect } from "react";

export const useTermly = () =>
	useEffect(() => {
		((id) => {
			const d = document;
			const js = d.createElement("script");
			const tjs = d.getElementsByTagName("script")[0]!;
			if (d.getElementById(id)) return;
			js.id = id;
			js.src = "https://app.termly.io/embed-policy.min.js";
			tjs.parentNode!.insertBefore(js, tjs);
		})("termly-jssdk");
	}, []);

export const TermlyPolicy: FC<{ id: string }> = ({ id }) => (
	<section className="md:max-w-7xl sm:max-w-5xl px-6 mx-auto flex items-center justify-center py-12">
		<div
			className="w-full"
			/* @ts-expect-error I can't control termly */
			name="termly-embed"
			data-id={id}
		/>
	</section>
);
